import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import SectionHeader from "components/dashboard/SectionHeader";

import Stats from "./components/Stats";
import OrderStatuses from "./components/OrderStatuses";

import {UserAgentUtils} from "utils/useragent";

function PerformanceResume({ ordersData, loading, currency, organizationName, retailer = null}) {
    const statusCount = ordersData?.statusCount ?? {};

    return (
        <div>
            <SectionHeader
                title={<FormattedMessage id="dashboard.performanceResume.title" />}
                subtitle={<FormattedMessage id="dashboard.performanceResume.subtitle" values={{ organizationName: organizationName ?? "" }} />}
            />
            <div style={{marginTop: UserAgentUtils.isMobile() ? '0': "16px"}}>
                <Stats
                    ordersData={ordersData}
                    loading={loading}
                    currency={currency}
                    isOrganizationDashboard={retailer === null}
                />
                <div style={{marginTop: "24px"}}>
                    <OrderStatuses
                        statusCount={statusCount}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
}

PerformanceResume.propTypes = {
    ordersData: PropTypes.object,
    loading: PropTypes.bool,
    currency: PropTypes.string,
    organizationName: PropTypes.string,
    retailer: PropTypes.string,
};

export default PerformanceResume;
